(function() {
  'use strict';

  angular.module('cfn').filter('toArray', toArrayFilter);

  function toArrayFilter() {
    return function(object) {
      if (object === undefined) {
        return;
      }

      var keys = Object.keys(object);

      return keys.map(function(key) {
        return {
          key: key,
          value: object[key]
        };
      });
    };
  }
})();
